import { render, staticRenderFns } from "./Summaries.vue?vue&type=template&id=5f591863&scoped=true&"
import script from "./Summaries.vue?vue&type=script&lang=js&"
export * from "./Summaries.vue?vue&type=script&lang=js&"
import style0 from "./Summaries.vue?vue&type=style&index=0&id=5f591863&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f591863",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VContainer,VDataTable})
